/** @format */

import React, { useState, useEffect } from "react";
import { RadioButton } from "primereact/radiobutton";
import OtherInfoWrapper from "./OtherInfo.style";
import { classNames } from "primereact/utils";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Dropdown } from "primereact/dropdown";
import { useTranslation } from "react-i18next";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { NationalityList, medmalApiRequestCommonData } from "../../helpers/utils";
import { getNationalList, getOccupationList } from "../../services/commonServices/index";
import {
  placeofbirthList,
  MaritalStatusList,
  ZoneList,
  sourceofIncomeList,
  IdentificationList,
} from "../../helpers/utils";
import * as globalUtils from "../../helpers/utils";
import { getKYCCity } from "services/medmal-service";
import CalendarIcon from "assets/images/icons/components/CalendarIcon";

const OtherInfo = (props) => {
  const {
    formik,
    // OccupationList = professionList,
    disableInput = false,
    otherInfoHeading = false,
    openTab,
    setOpenTab
  } = props;
  const [activeIndex, setActiveIndex] = useState(props.activeIndex);
  const [accordionKey, setAccordionKey] = useState(0);
  const { i18n, t } = useTranslation();
  const LANG = i18n.language.slice(0, 1).toUpperCase();
  const currentLanguageCode = i18n.language || "en";
  const showRTL = currentLanguageCode === "ar";


  const [nationalListAPI, setNationalListAPI] = useState([]);
  const [occupationListAPIData, setOccupationListAPIData] = useState(props.professionList);
  const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
  };

  useEffect(() => {
    const nationalListData = {
      nationalityCode: "",
      source: "TRVL",
      languageCode: currentLanguageCode == "en" ? "E" : "A",
      channelCode: "85",
    };
    const occupationListData = {
      occupationCode: "",
      source: "TRVL",
      languageCode: currentLanguageCode == "en" ? "E" : "A",
      channelCode: "85",
    };

    if (currentLanguageCode) {
      getNationalList(nationalListData).then((res) => {
        setNationalListAPI(res.NationalityDescription);
      });
      getOccupationList(occupationListData).then((res) => {
        setOccupationListAPIData(props.professionList ? props.professionList : res.OccupationDescription);
      });
    }
  }, [currentLanguageCode]);
  const [accordian, toggleAccordian] = useState(false);
  const [cityList, setCityList] = useState([{ description: "unknown", cityCode: "unknown" }]);

  useEffect(() => {
    let request = {
      languageCode: LANG,
      regionCode: formik.values.Zone.regionCode || "1",
      ...medmalApiRequestCommonData,
    };
    getKYCCity(request).then((res) => {
      let data = data.cityDetailsArray || []
      setCityList(data);
      const getCity = !res || res === "" || res === undefined ? "" : res.data.cityDetailsArray.find(obj => {
        return obj.cityCode === formik.values.City;
      });
      if (props.setCityData) props.setCityData(getCity);
    });
  }, [formik.values.Zone, LANG]);

  // console.log(activeIndex,'activeIndex###');

  const numbersTemplate = (option, props) => {
    if (option) {
      return <div className="numbers_drop">{option.occupationDescription}</div>;
    }
    return <span>{props.placeholder}</span>;
  };


  useEffect(() => {
    const natList = [...NationalityList]
    if (formik.values?.Nationality?.nationalityCode) {
      const nationality = { ...natList.find(el => el.nationality_code === formik.values.Nationality.nationalityCode) };
      formik.setFieldValue('Nationality', { nationalityCode: nationality.nationality_code, nationalityDescription: (i18n.language === 'ar' ? nationality.nationality_descAr : nationality.nationality_descEn) })
    }
  }, [NationalityList, i18n.language]);


  const handleKeyPress = (e) => {
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "+"];

    // Allow backspace, plus sign (+), and numbers
    if (!allowedKeys.includes(e.key) && (isNaN(Number(e.key)) || e.key === " ")) {
      e.preventDefault();
    }

    // Limit input to 13 characters
    if (e.target.value.length >= 13 && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    if (openTab) {
      setActiveIndex(0);
      setAccordionKey(prevKey => prevKey + 1);
    } else {
      setActiveIndex(1);
      setAccordionKey(prevKey => prevKey + 1);
    }
  }, [openTab]);

  return (
    <OtherInfoWrapper businessColor={props.businessColor || globalUtils.BUSINESS_LINE_COLORS.DEFAULT}>
      <div className="conatiner Acc-det">
        <Accordion
          key={accordionKey}
          onTabOpen={() => setOpenTab(true)}
          onTabClose={() => setOpenTab(false)}
          activeIndex={activeIndex}
        >
          <AccordionTab
            tabIndex={0}
            header={
              <React.Fragment>
                <div className="flex-container">
                  <React.Fragment>
                    <div className="header-flex">
                      <div className="Heading-dec w-100">
                        <div className="head-icon"></div>
                        {otherInfoHeading ? "Other Information" : i18n.t("other_info.title")}
                        {props.errorShow && <> <br /><small className="p-error">{t("ERROR.KYC_ERROR")}</small></>}
                      </div>
                      <div className="Icon-Div">
                        {accordian ? (
                          <i className="pi pi-chevron-up accordianIcon up-acc"></i>
                        ) : (
                          <i className="pi pi-chevron-down accordianIcon down-acc"></i>
                        )}
                      </div>
                    </div>
                  </React.Fragment>
                </div>
              </React.Fragment>
            }>
            <form onSubmit={formik.submit} className="">
              <div className="inner-content">
                <div className="row Firstinfo">
                  <div className="Subheading-oth">{i18n.t("other_info.identify_details")}</div>
                  <div className="col-md-6 col-xs-12 mt-2">
                    <div className="Dec-Input">
                      <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                        <InputText
                          id="nationalId"
                          name="nationalId"
                          value={formik.values.nationalId}
                          onChange={formik.handleChange}
                          inputMode="numeric"
                          maxLength={10}
                          keyfilter="int"
                          className="fm-tawuniya"
                          disabled={disableInput || props.nationalIdDisable}
                        />
                        <label>{i18n.t("other_info.id_no")}</label>
                      </span>
                      {getFormErrorMessage("nationalId")}
                    </div>
                  </div>

                  <div className="col-md-6 col-xs-12 mt-2">
                    <div className="SerialID">
                      <div className="p-inputgroup">
                        <span className="p-float-label">
                          <Dropdown
                            id="identificationType"
                            name="identificationType"
                            value={formik.values.identificationType}
                            options={IdentificationList}
                            onChange={formik.handleChange}
                            optionLabel={i18n.language === "ar" ? "descriptionAr" : "descriptionEn"}
                            //tooltip="National ID"
                            title="National ID"
                            disabled={disableInput || props.nationalIdDisable}
                          />
                          <label htmlFor="repair">{i18n.t("other_info.identify_type")}</label>
                        </span>
                      </div>
                    </div>
                    {getFormErrorMessage("identificationType")}
                  </div>
                </div>
                {/* <div className="row Secondinfo">
									<div className="col-md-12 col-xs-12 mt-2">
										<div className="SerialID">
											<div className="p-inputgroup">
												<span className="p-float-label">
													<Dropdown
														name="placeofIssue"
														value={formik.values.placeofIssue}
														options={placeofbirthList}
														onChange={formik.handleChange}
														optionLabel="description"
														disabled={props.placeofIssueDisable || disableInput}
													/>
													<label htmlFor="repair">
														{i18n.t("other_info.place_issue")}
													</label>
												</span>
											</div>
										</div>
										{getFormErrorMessage("placeofIssue")}
									</div>
								</div> */}

                <div className="row Thirdinfo mt-3">
                  <div className="Subheading-oth">{i18n.t("other_info.app_details")}</div>

                  <div className="col-md-12 col-xs-12 mt-2">
                    <div className="Dec-Input">
                      <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                        <InputText
                          id="FullName"
                          name="FullName"
                          value={formik.values.FullName}
                          onChange={formik.handleChange}
                          disabled={props.fullNameDisable}
                        />
                        <label>{i18n.t("other_info.full_name")}</label>
                      </span>
                      {getFormErrorMessage("FullName")}
                    </div>
                  </div>

                  <div className="col-md-6 col-xs-12 mt-2">
                    <div className="calender">
                      <span className="p-float-label">
                        <Calendar
                          id="dateofBirth"
                          value={formik.values.dateofBirth}
                          name="dateofBirth"
                          onChange={formik.handleChange}
                          dateFormat="dd-mm-yy"
                          showIcon
                          iconPos="left"
                          maxDate={new Date()}
                          disabled={props.dobDisable}
                          icon={<CalendarIcon color={props.businessColor || globalUtils.BUSINESS_LINE_COLORS.DEFAULT} />}
                        />
                        <label className={showRTL ? " label-ar" : "label-en"}>
                          {i18n.t("other_info.dob")}
                        </label>
                      </span>
                    </div>
                    {getFormErrorMessage("dateofBirth")}
                  </div>
                  <div className="col-md-6 col-xs-12 mt-2">
                    <div className="SerialID">
                      <div className="p-inputgroup">
                        <span className="p-float-label">
                          <Dropdown
                            id="placeofbirth"
                            name="placeofbirth"
                            value={formik.values.placeofbirth}
                            options={placeofbirthList}
                            onChange={formik.handleChange}
                            optionLabel={i18n.language === "ar" ? "descriptionEn" : "descriptionEn"}
                            disabled={disableInput || disableInput}
                            filter
                          />
                          <label htmlFor="repair">{i18n.t("other_info.place_birth")}</label>
                        </span>
                      </div>
                    </div>
                    {getFormErrorMessage("placeofbirth")}
                  </div>

                  <div className="col-md-6 col-xs-12 mt-2">
                    {" "}
                    <div className="SerialID">
                      <div className="p-inputgroup">
                        <span className="p-float-label">
                          <Dropdown
                            id="placeofIssue"
                            name="placeofIssue"
                            value={formik.values.placeofIssue}
                            options={placeofbirthList}
                            onChange={formik.handleChange}
                            optionLabel={i18n.language === "ar" ? "descriptionEn" : "descriptionEn"}
                            disabled={disableInput}
                            filter
                          />
                          <label htmlFor="repair">{i18n.t("other_info.place_issue")}</label>
                        </span>
                      </div>
                    </div>
                    {getFormErrorMessage("placeofIssue")}
                  </div>
                  <div className="col-md-6 col-xs-12 mt-2">
                    {" "}
                    <div className="calender">
                      <span className="p-float-label">
                        <Calendar
                          id="expDate"
                          value={formik.values.expDate}
                          name="expDate"
                          onChange={formik.handleChange}
                          dateFormat="dd-mm-yy"
                          showIcon
                          iconPos="left"
                          disabled={props.expiryDateDisable || disableInput}
                          icon={<CalendarIcon color={props.businessColor || globalUtils.BUSINESS_LINE_COLORS.DEFAULT} />}
                        />
                        <p className="exp-date">{i18n.t("other_info.exp_date")}</p>
                      </span>
                    </div>
                    {getFormErrorMessage("expDate")}
                  </div>

                  <div className="col-md-6 col-xs-12 mt-2">
                    {" "}
                    <div className="SerialID">
                      <div className="p-inputgroup">
                        <span className="p-float-label">
                          <Dropdown
                            id="Nationality"
                            name="Nationality"
                            value={formik.values.Nationality.nationalityCode}
                            options={nationalListAPI}
                            onChange={e=> {
                              const value = e.value;
                              const index = nationalListAPI.findIndex(result => result.nationalityCode === value);
                              if (index >= 0) {
                                formik.setFieldValue('Nationality', {
                                  nationalityCode: value,
                                  nationalityDescription: nationalListAPI[index].nationalityDescription,
                                });
                              }
                            }}
                            optionLabel={"nationalityDescription"}
                            optionValue={"nationalityCode"}
                            disabled={props.nationalityDisable || disableInput}
                            filter
                          />
                          <label htmlFor="repair">{i18n.t("other_info.nationality")}</label>
                        </span>
                      </div>
                    </div>
                    {getFormErrorMessage("Nationality")}
                  </div>
                  <div className="col-md-6 col-xs-12 mt-2">
                    {" "}
                    <div className="SerialID">
                      <div className="p-inputgroup">
                        <span className="p-float-label">
                          <Dropdown
                            className="position-dropdown"
                            name="MaritalStatus"
                            id="MaritalStatus"
                            value={formik.values.MaritalStatus.maritalStatusCode}
                            options={MaritalStatusList}
                            onChange={e=> {
                              const value = e.value;
                              const index = MaritalStatusList.findIndex(result => result.maritalStatusCode === value);
                              if (index >= 0) {
                                formik.setFieldValue('MaritalStatus', {
                                  maritalStatusCode: value,
                                  maritalStatus: MaritalStatusList[index].maritalStatus,
                                  maritalStatusAR: MaritalStatusList[index].maritalStatusAR
                                });
                              }
                            }}
                            optionLabel={
                              i18n.language === "ar" ? "maritalStatusAR" : "maritalStatus"
                            }
                            optionValue="maritalStatusCode"
                            disabled={disableInput}
                          />
                          <label htmlFor="repair">{i18n.t("other_info.martial_status")}</label>
                        </span>
                      </div>
                    </div>
                    {getFormErrorMessage("MaritalStatus")}
                  </div>
                  <div className="col-md-6 col-xs-12 mt-2">
                    {" "}
                    <div className="Dec-Input">
                      <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                        <InputText
                          id="MobileNo"
                          name="MobileNo"
                          className={`font-bliss fm-tawuniyafm-tawuniya ${currentLanguageCode === 'ar' ? 'mobile-no-direction-ar' : ''}`}
                          value={formik.values.MobileNo}
                          onChange={formik.handleChange}
                          onKeyDown={handleKeyPress}
                        // disabled={props.mobileNumberDisable || disableInput}
                        />
                        <label>{i18n.t("other_info.mob_no")}</label>
                      </span>
                      {getFormErrorMessage("MobileNo")}
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-12 mt-2">
                    {" "}
                    <div className="Dec-Input">
                      <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                        <InputText
                          name="Email"
                          id="Email"
                          value={formik.values.Email}
                          onChange={formik.handleChange}
                          // disabled={props.emailDisable || disableInput}
                          className="fm-tawuniya"

                        />
                        <label>{i18n.t("other_info.email")}</label>
                      </span>
                      {getFormErrorMessage("Email")}
                    </div>
                  </div>

                  <div className="col-md-6 col-xs-12 mt-2">
                    {" "}
                    <div className="SerialID">
                      <div className="p-inputgroup">
                        <span className="p-float-label">
                          <Dropdown
                            id="Occupation"
                            name="Occupation"
                            value={formik.values?.Occupation?.occupationCode}
                            options={occupationListAPIData}
                            onChange={e=> {
                              const value = e.value;
                              const index = occupationListAPIData.findIndex(result => result.occupationCode === value);
                              if (index >= 0) {
                                formik.setFieldValue('Occupation', {
                                  occupationCode: value,
                                  occupationDescription: occupationListAPIData[index].occupationDescription,
                                });
                              }
                            }}
                            optionLabel={"occupationDescription"}
                            optionValue="occupationCode"
                            filter
                            filterPlaceholder={i18n.t("POLICY.PROFESSION")}
                            filterBy="occupationDescription"
                            itemTemplate={numbersTemplate}
                            disabled={disableInput || props.occupationDisable}
                          />
                          <label htmlFor="repair">{i18n.t("other_info.occupation")}</label>
                        </span>
                      </div>
                    </div>
                    {getFormErrorMessage("Occupation")}
                  </div>
                  <div className="col-md-6 col-xs-12 mt-2">
                    {" "}
                    <div className="SerialID">
                      <div className="p-inputgroup">
                        <span className="p-float-label">
                          <Dropdown
                            id="sourceofIncome"
                            name="sourceofIncome"
                            value={formik.values.sourceofIncome.code}
                            options={sourceofIncomeList}
                            onChange={e=> {
                              const value = e.value;
                              const index = sourceofIncomeList.findIndex(result => result.code === value);
                              if (index >= 0) {
                                formik.setFieldValue('sourceofIncome', {
                                  code: value,
                                  description: currentLanguageCode === 'ar' ? sourceofIncomeList[index].descriptionAr : sourceofIncomeList[index].descriptionEn,
                                });
                              }
                            }}
                            optionLabel={i18n.language === "ar" ? "descriptionAr" : "descriptionEn"}
                            optionValue="code"
                            disabled={disableInput}
                            filter
                          />
                          <label htmlFor="repair">{i18n.t("other_info.source_income")}</label>
                        </span>
                      </div>
                    </div>
                    {getFormErrorMessage("sourceofIncome")}
                  </div>
                </div>

                <div className="row Fourthinfo mt-3">
                  <div className="Subheading-oth">{i18n.t("other_info.national_address")}</div>
                  <div className="col-md-6 col-xs-12 mt-2">
                    <div className="SerialID">
                      <div className="p-inputgroup">
                        <span className="p-float-label">
                          <Dropdown
                            id="Zone"
                            name="Zone"
                            value={formik.values.Zone}
                            options={ZoneList}
                            onChange={formik.handleChange}
                            optionLabel={i18n.language === "ar" ? "descriptionAr" : "descriptionEn"}
                            optionValue="regionCode"
                            disabled={props.regionDisable}
                            filter
                          />
                          <label htmlFor="repair">{i18n.t("other_info.zone")}</label>
                        </span>
                      </div>
                    </div>
                    {getFormErrorMessage("Zone")}
                  </div>

                  <div className="col-md-6 col-xs-12 mt-2">
                    <div className="SerialID">
                      <div className="p-inputgroup">
                        <span className="p-float-label">
                          <Dropdown
                            id="City"
                            name="City"
                            value={formik.values.City}
                            options={cityList}
                            onChange={formik.handleChange}
                            optionLabel="description"
                            optionValue="cityCode"
                            disabled={props.cityDisable || disableInput}
                            filter
                          />
                          <label htmlFor="repair">{i18n.t("other_info.city")}</label>
                        </span>
                      </div>
                    </div>
                    {getFormErrorMessage("City")}
                  </div>

                  <div className="col-md-6 col-xs-12 mt-2">
                    <div className="SerialID">
                      <div className="p-inputgroup">
                        <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                          <InputText
                            id="Disctrict"
                            name="Disctrict"
                            value={formik.values.Disctrict}
                            onChange={formik.handleChange}
                            disabled={props.Disctrict || disableInput}
                          />
                          <label htmlFor="repair">{i18n.t("other_info.district")}</label>
                        </span>
                      </div>
                    </div>
                    {getFormErrorMessage("Disctrict")}
                  </div>

                  <div className="col-md-6 col-xs-12 mt-2">
                    <div className="Dec-Input dec-lbl">
                      <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                        <InputText
                          id="Street"
                          name="Street"
                          value={formik.values.Street}
                          className="font-bliss"
                          onChange={formik.handleChange}
                          disabled={props.streetDisable}
                        />
                        <label>{i18n.t("other_info.street")}</label>
                      </span>
                      {getFormErrorMessage("Street")}
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-12 mt-2">
                    <div className="Dec-Input dec-lbl">
                      <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                        <InputText
                          id="buildingNo"
                          name="buildingNo"
                          className="font-bliss fm-tawuniyafm-tawuniya"
                          value={formik.values.buildingNo}
                          onChange={formik.handleChange}
                          disabled={props.buildingDisable}

                        />
                        <label>{i18n.t("other_info.build_no")}</label>
                      </span>
                      {getFormErrorMessage("buildingNo")}
                    </div>
                  </div>

                  <div className="col-md-6 col-xs-12 mt-2">
                    <div className="Dec-Input dec-lbl">
                      <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                        <InputText
                          id="UnitNo"
                          name="UnitNo"
                          className="font-bliss fm-tawuniyafm-tawuniya"
                          value={formik.values.UnitNo}
                          onChange={formik.handleChange}
                          disabled={props.unitDisable || disableInput}
                          inputMode="numeric"
                          maxLength={12}
                          keyfilter="int"


                        />
                        <label>{i18n.t("other_info.unit_no")}</label>
                      </span>
                      {getFormErrorMessage("UnitNo")}
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-12 mt-2">
                    <div className="Dec-Input">
                      <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                        <InputText
                          id="ZipCode"
                          name="ZipCode"
                          className="font-bliss fm-tawuniyafm-tawuniya"
                          value={formik.values.ZipCode}
                          onChange={formik.handleChange}
                          disabled={props.zipDisable}
                          inputMode="numeric"
                          maxLength={6}
                          keyfilter="int"

                        />
                        <label>{i18n.t("other_info.zip")}</label>
                      </span>
                      {getFormErrorMessage("ZipCode")}
                    </div>
                  </div>

                  <div className="col-md-6 col-xs-12 mt-2">
                    <div className="Dec-Input dec-lbl">
                      <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                        <InputText
                          id="Additionalnumber"
                          name="Additionalnumber"
                          value={formik.values.Additionalnumber}
                          onChange={formik.handleChange}
                          disabled={props.additionalNumberDisable}
                          className={classNames({
                            "p-invalid": isFormFieldValid("estimateAmount"),
                          }) + "font-bliss"}
                          inputMode="numeric"
                          maxLength={12}
                          keyfilter="int"
                        />
                        <label>{i18n.t("other_info.add_no")}</label>
                      </span>
                      {getFormErrorMessage("Additionalnumber")}
                    </div>
                  </div>
                </div>

                <div className="row Fiveinfo mt-2">
                  <div className="col-md-12 mt-4">
                    <div className="Subheading">{i18n.t("other_info.ques_1")} </div>
                    <div className="d-flex mt-2">
                      <div className="field-radiobutton mx-2">
                        <RadioButton
                          id="Attoney"
                          inputId="insure2"
                          name="Attoney"
                          value="No"
                          onChange={formik.handleChange}
                          checked={formik.values.Attoney === "No"}
                          disabled={disableInput}
                        />
                        <label htmlFor="insure2" className="mx-2">
                          {i18n.t("PERSONAL_DETAIL.NO")}
                        </label>
                      </div>
                      <div className="field-radiobutton mx-2">
                        <RadioButton
                          id="Attoney"
                          inputId="insure"
                          name="Attoney"
                          value="Yes"
                          // onChange={(e) => {
                          // 	setOwnerDriving(e.value);
                          // 	// setVehicleInsure(e.value);
                          // }}
                          onChange={formik.handleChange}
                          checked={formik.values.Attoney === "Yes"}
                          disabled={disableInput}
                        />
                        <label htmlFor="insure" className="mx-2">
                          {i18n.t("PERSONAL_DETAIL.YES")}
                        </label>
                      </div>
                    </div>
                  </div>
                  {formik.values.Attoney === "Yes" ? (
                    <>
                      <div className="col-md-6 mt-3">
                        <div className="Dec-Input">
                          <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                            <InputText
                              id="AuthAuthroney"
                              name="AuthAuthroney"
                              value={formik.values.AuthAuthroney}
                              onChange={formik.handleChange}
                              // disabled={props.buildingDisable || disableInput}
                              keyfilter="alpha"
                            />
                            <label>{i18n.t("other_info.name_authorized")}</label>
                          </span>
                          {getFormErrorMessage("AuthAuthroney")}
                        </div>
                      </div>

                      <div className="col-md-6 mt-3">
                        <div className="Dec-Input">
                          <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                            <InputText
                              id="authnumber"
                              value={formik.values.authnumber}
                              onChange={formik.handleChange}
                              //disabled={disableInput}
                              inputMode="numeric"
                              keyfilter="int"
                              maxLength={9}
                            //placeholder="5XXXXXXXX"
                            />
                            <label>{i18n.t("other_info.attorney_no")}</label>
                          </span>
                          {getFormErrorMessage("authnumber")}
                        </div>
                      </div>

                      <div className="col-md-6 mt-2">
                        <div className="Dec-Input">
                          <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                            <InputText
                              id="atidcardNo"
                              name="atidcardNo"
                              value={formik.values.atidcardNo}
                              onChange={formik.handleChange}
                              inputMode="numeric"
                              keyfilter="int"
                              maxLength={10}
                            // disabled={disableInput}
                            />
                            <label>{i18n.t("other_info.id_cardno")}</label>
                          </span>
                          {getFormErrorMessage("atidcardNo")}
                        </div>
                      </div>

                      <div className="col-md-6 col-xs-12 mt-2">
                        <div className="calender">
                          <span className="p-float-label">
                            <Calendar
                              id="atdateofExpiry"
                              value={formik.values.atdateofExpiry}
                              name="atdateofExpiry"
                              onChange={formik.handleChange}
                              dateFormat="dd-mm-yy"
                              showIcon
                              iconPos="left"
                            // maxDate={new Date()}
                            />
                            <label className={showRTL ? " label-ar" : "label-en"}>
                              {i18n.t("other_info.exp_date")}
                            </label>
                          </span>
                        </div>
                        {getFormErrorMessage("atdateofExpiry")}
                      </div>

                      <div className="col-md-6 col-xs-12 mt-2">
                        <div className="calender">
                          <span className="p-float-label">
                            <Calendar
                              id="atdateofBIRTH"
                              value={formik.values.atdateofBIRTH}
                              name="atdateofBIRTH"
                              onChange={formik.handleChange}
                              dateFormat="dd-mm-yy"
                              showIcon
                              iconPos="left"
                              maxDate={new Date()}
                            />
                            <label className={showRTL ? " label-ar" : "label-en"}>
                              {i18n.t("other_info.dob")}
                            </label>
                          </span>
                        </div>
                        {getFormErrorMessage("atdateofBIRTH")}
                      </div>
                      <div className="col-md-6 col-xs-12 mt-2">
                        <div className="SerialID">
                          <div className="p-inputgroup">
                            <span className="p-float-label">
                              <Dropdown
                                id="atplaceofbirth"
                                name="atplaceofbirth"
                                value={formik.values.atplaceofbirth}
                                options={placeofbirthList}
                                onChange={formik.handleChange}
                                optionLabel={
                                  i18n.language === "ar" ? "descriptionEn" : "descriptionEn"
                                }
                                filter
                              />
                              <label htmlFor="repair">{i18n.t("other_info.place_birth")}</label>
                            </span>
                          </div>
                        </div>
                        {getFormErrorMessage("atplaceofbirth")}
                      </div>

                      <div className="col-md-6 mt-2">
                        <div className="Dec-Input">
                          <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                            <InputText
                              id="atrelationship"
                              name="atrelationship"
                              value={formik.values.atrelationship}
                              onChange={formik.handleChange}
                              disabled={disableInput}
                            />
                            <label>{i18n.t("other_info.relationship")}</label>
                          </span>
                          {getFormErrorMessage("atrelationship")}
                        </div>
                      </div>

                      <div className="col-md-6 mt-2">
                        <div className="Dec-Input">
                          <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                            <InputText
                              id="atauthrization"
                              name="atauthrization"
                              value={formik.values.atauthrization}
                              onChange={formik.handleChange}
                              disabled={disableInput}
                            />
                            <label>{i18n.t("other_info.type_auth")}</label>
                          </span>
                          {getFormErrorMessage("atauthrization")}
                        </div>
                      </div>

                      <div className="col-md-6 col-xs-12 mt-2">
                        <div className="SerialID">
                          <div className="p-inputgroup">
                            <span className="p-float-label">
                              <Dropdown
                                id="atCity"
                                name="atCity"
                                value={formik.values.atCity}
                                options={cityList}
                                onChange={formik.handleChange}
                                optionLabel="description"
                                optionValue="cityCode"
                                // disabled={props.cityDisable || disableInput}
                                filter
                              />
                              <label htmlFor="repair">{i18n.t("other_info.city")}</label>
                            </span>
                          </div>
                        </div>
                        {getFormErrorMessage("atCity")}
                      </div>

                      <div className="col-md-6 mt-2">
                        <div className="Dec-Input">
                          <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                            <InputText
                              id="atDistract"
                              name="atDistract"
                              value={formik.values.atDistract}
                              onChange={formik.handleChange}
                              disabled={disableInput}
                            />
                            <label>{i18n.t("other_info.district")}</label>
                          </span>
                          {getFormErrorMessage("atDistract")}
                        </div>
                      </div>
                      {/* <div className="col-md-6 col-xs-12 mt-2">
                        <div className="SerialID">
                          <div className="p-inputgroup">
                            <span className="p-float-label">
                              <InputText
                                className="margin-bott"
                                id="atDisctrict"
                                name="atDistract"
                                value={formik.values.atDisctrict}
                                onChange={formik.handleChange}
                              />
                              <label htmlFor="repair lable-dist">
                                {i18n.t("other_info.district")}
                              </label>
                            </span>
                          </div>
                        </div>
                        {getFormErrorMessage("atDistract")}
                      </div> */}

                      {/* <div className="Fourthinfo mt-3 check"> */}
                      <div className="Subheading-oth mt-3">
                        {i18n.t("other_info.national_address")}
                      </div>
                      <div className="col-md-6 col-xs-12 mt-2">
                        <div className="SerialID">
                          <div className="p-inputgroup">
                            <span className="p-float-label">
                              <Dropdown
                                id="atNatCity"
                                name="atNatCity"
                                value={formik.values.atNatCity}
                                options={cityList}
                                onChange={formik.handleChange}
                                optionLabel="description"
                                optionValue="cityCode"
                                filter
                              />
                              <label htmlFor="repair">{i18n.t("other_info.city")}</label>
                            </span>
                          </div>
                        </div>
                        {getFormErrorMessage("atNatCity")}
                      </div>

                      <div className="col-md-6 col-xs-12 mt-2">
                        <div className="SerialID">
                          <div className="p-inputgroup">
                            <span className="p-float-label">
                              <Dropdown
                                id="atnatZone"
                                name="atnatZone"
                                value={formik.values.atnatZone}
                                options={ZoneList}
                                onChange={formik.handleChange}
                                optionLabel={
                                  i18n.language === "ar" ? "descriptionEn" : "descriptionEn"
                                }
                                filter
                              />

                              <label htmlFor="repair">{i18n.t("other_info.zone")}</label>
                            </span>
                          </div>
                        </div>
                        {getFormErrorMessage("atnatZone")}
                      </div>

                      <div className="col-md-6 col-xs-12 mt-2">
                        <div className="SerialID">
                          <div className="p-inputgroup">
                            <span className="p-float-label">
                              <InputText
                                id="attDisctrict"
                                name="attDisctrict"
                                value={formik.values.attDisctrict}
                                onChange={formik.handleChange}
                              />
                              <label htmlFor="repair">{i18n.t("other_info.district")}</label>
                            </span>
                          </div>
                        </div>
                        {getFormErrorMessage("attDisctrict")}
                      </div>

                      <div className="col-md-6 col-xs-12 mt-2">
                        <div className="Dec-Input">
                          <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                            <InputText
                              id="atStreet"
                              name="atStreet"
                              value={formik.values.atStreet}
                              onChange={formik.handleChange}
                            />
                            <label>{i18n.t("other_info.street")}</label>
                          </span>
                          {getFormErrorMessage("atStreet")}
                        </div>
                      </div>
                      <div className="col-md-6 col-xs-12 mt-2">
                        <div className="Dec-Input">
                          <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                            <InputText
                              id="atbuildingNo"
                              name="atbuildingNo"
                              value={formik.values.atbuildingNo}
                              onChange={formik.handleChange}
                            />
                            <label>{i18n.t("other_info.build_no")}</label>
                          </span>
                          {getFormErrorMessage("atbuildingNo")}
                        </div>
                      </div>

                      <div className="col-md-6 col-xs-12 mt-2">
                        <div className="Dec-Input">
                          <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                            <InputText
                              id="atUnitNo"
                              name="atUnitNo"
                              value={formik.values.atUnitNo}
                              onChange={formik.handleChange}
                              inputMode="numeric"
                              maxLength={12}
                              keyfilter="int"
                            />
                            <label>{i18n.t("other_info.unit_no")}</label>
                          </span>
                          {getFormErrorMessage("atUnitNo")}
                        </div>
                      </div>
                      <div className="col-md-6 col-xs-12 mt-2">
                        <div className="Dec-Input">
                          <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                            <InputText
                              id="atZipCode"
                              name="atZipCode"
                              value={formik.values.atZipCode}
                              onChange={formik.handleChange}
                              inputMode="numeric"
                              maxLength={6}
                              keyfilter="int"
                            />
                            <label>{i18n.t("other_info.zip")}</label>
                          </span>
                          {getFormErrorMessage("atZipCode")}
                        </div>
                      </div>

                      <div className="col-md-6 col-xs-12 mt-2">
                        <div className="Dec-Input">
                          <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                            <InputText
                              id="atAdditionalnumber"
                              name="atAdditionalnumber"
                              value={formik.values.atAdditionalnumber}
                              onChange={formik.handleChange}
                              className={classNames({
                                "p-invalid": isFormFieldValid("estimateAmount"),
                              })}
                              inputMode="numeric"
                              maxLength={12}
                              keyfilter="int"
                            />
                            <label>{i18n.t("other_info.add_no")}</label>
                          </span>
                          {getFormErrorMessage("atAdditionalnumber")}
                        </div>
                      </div>
                      {/* </div> */}
                    </>
                  ) : (
                    ""
                  )}
                </div>

                <div className="row Fiveinfo mt-2">
                  <div className="col-md-12 mt-4">
                    <div className="Subheading">{i18n.t("other_info.ques_2")}</div>
                    <div className="d-flex mt-2">
                      <div className="field-radiobutton mx-2">
                        <RadioButton
                          inputId="insure2"
                          name="Policyowner"
                          value="No"
                          onChange={formik.handleChange}
                          checked={formik.values.Policyowner === "No"}
                          disabled={disableInput}
                        />
                        <label htmlFor="insure2" className="mx-2">
                          {i18n.t("PERSONAL_DETAIL.NO")}
                        </label>
                      </div>
                      <div className="field-radiobutton mx-2">
                        <RadioButton
                          inputId="insure"
                          id="Policyowner"
                          name="Policyowner"
                          value="Yes"
                          // onChange={(e) => {
                          // 	setOwnerDriving(e.value);
                          // 	// setVehicleInsure(e.value);
                          // }}
                          onChange={formik.handleChange}
                          checked={formik.values.Policyowner === "Yes"}
                          disabled={disableInput}
                        />
                        <label htmlFor="insure" className="mx-2">
                          {i18n.t("PERSONAL_DETAIL.YES")}
                        </label>
                      </div>
                    </div>
                  </div>
                  {formik.values.Policyowner === "No" ? (
                    <>
                      <div className="col-md-6 mt-3">
                        <div className="Dec-Input">
                          <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                            <InputText
                              id="PolicyOName"
                              name="PolicyOName"
                              value={formik.values.PolicyOName}
                              onChange={formik.handleChange}
                              disabled={disableInput}
                              keyfilter="alpha"
                            />
                            <label>{i18n.t("other_info.name")}</label>
                          </span>
                          {getFormErrorMessage("PolicyOName")}
                        </div>
                      </div>

                      <div className="col-md-6 mt-3">
                        <div className="Dec-Input">
                          <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                            <InputText
                              id="PolciyidCard"
                              name="PolciyidCard"
                              value={formik.values.PolciyidCard}
                              onChange={formik.handleChange}
                              disabled={disableInput}
                              keyfilter="int"
                            />
                            <label>{i18n.t("other_info.id_cardno")}</label>
                          </span>
                          {getFormErrorMessage("PolciyidCard")}
                        </div>
                      </div>
                      <div className="col-md-6 col-xs-12 mt-2">
                        {" "}
                        <div className="SerialID">
                          <div className="p-inputgroup">
                            <span className="p-float-label">
                              <Dropdown
                                id="PolcyNationality"
                                name="PolcyNationality"
                                value={formik.values.PolcyNationality}
                                options={nationalListAPI}
                                onChange={formik.handleChange}
                                optionLabel={"nationalityDescription"}
                                filter
                              />
                              <label htmlFor="repair">{i18n.t("other_info.nationality")}</label>
                            </span>
                          </div>
                        </div>
                        {getFormErrorMessage("PolcyNationality")}
                      </div>
                      <div className="col-md-6 mt-2">
                        <div className="Dec-Input">
                          <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                            <InputText
                              id="atPolicyrelationship"
                              name="atPolicyrelationship"
                              value={formik.values.atPolicyrelationship}
                              onChange={formik.handleChange}
                              disabled={disableInput}
                            />
                            <label>{i18n.t("other_info.relationship")}</label>
                          </span>
                          {getFormErrorMessage("atPolicyrelationship")}
                        </div>
                      </div>

                      <div className="col-md-12 col-xs-12 mt-2">
                        <div className="Dec-Input">
                          <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                            <InputText
                              id="Payjust"
                              name="Payjust"
                              value={formik.values.Payjust}
                              onChange={formik.handleChange}
                              disabled={disableInput}
                            />
                            <label>{i18n.t("other_info.payment")}</label>
                          </span>
                          {getFormErrorMessage("Payjust")}
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </form>
          </AccordionTab>
        </Accordion>
      </div>
    </OtherInfoWrapper>
  );
};

export default OtherInfo;
